// extracted by mini-css-extract-plugin
module.exports = {"root":"_1SuGg","icons-wrapper":"M26I4","iconsWrapper":"M26I4","icon":"_1L4uL","left-block":"_22kWH","leftBlock":"_22kWH","right-block":"_1Xb-n","rightBlock":"_1Xb-n"};